import V from 'gcl/com/coooders/common/tool';
import N from 'gcl/com/coooders/db/ni';
import I from 'gcl/com/coooders/io/tool';
import { AModuler } from '../../V/Control/app';
import { AFilter } from '../../V/Control/core-modulers';
/**
 * LoginModuler:LoginModuler处理未登录时请求非过滤的动态页面，则弹回登录页
 */
export const LoginModuler = class extends AModuler {
    constructor(loginurl, igoreg = '.*', valid = 'html') {
        super("LoginModuler");
        const __ = {};
        valid.split(';').filter(v => V.isValid(v)).forEach(k => __[k] = true);
        pri(this, { loginurl, igoreg: new RegExp(igoreg, 'i'), valid: __ });
        if (!loginurl) throw new Error('必须定义默认登录页面!');
    }
    async onrequest(req, rep, session) {
        const { _, __ } = pri(this);
        const extend = session.url.pathname.split('.').slice(1).join('.') || '';
        if (__.valid[extend] && !__.igoreg.test(session.url.pathname) && !session.User.Login) {
            session.redirect(__.loginurl);
            return true;
        } else
            return false;
    }
};
export default { LoginModuler };
const pri = V.pris();